import ApiService, { USERS_API_HOST } from './ApiService';
import { v4 as uuidv4 } from 'uuid';
import { checkAppVersion } from '@/utils/app/checkAppVersion';
import LZString from 'lz-string';

/**
 * @override
 */
class AdminUsersService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: USERS_API_HOST });
    }

    /**
     * Get current user info
     * @param {Object} config Axios config
     * @return {Object} Response with list of users
     */
    async getMe(dni, config) {
        return await this.get(`/me/admin?dni=${dni}&is_private_area=true`, config).then(
            async response => {
                localStorage.setItem('DNI', dni);

                // Usar lz-string para comprimir el JSON
                const compressed = LZString.compressToUTF16(JSON.stringify(response.data));
                localStorage.setItem('PACOUS', compressed);

                await checkAppVersion(response.data.app_version_minimal);

                return response.data;
            }
        );
    }

    getPrivateAreaSectionIfExists() {
        const compressed = localStorage.getItem('PACOUS');
        if (compressed) {
            try {
                const decompressed = LZString.decompressFromUTF16(compressed);
                const parsed = JSON.parse(decompressed);
                return parsed.private_area;
            } catch (e) {
                console.error('Error al descomprimir PACOUS:', e);
                return null;
            }
        }
        return null;
    }

    getIntervenerFromLocalStore() {
        const privateArea = this.getPrivateAreaSectionIfExists();
        if (privateArea && privateArea.intervener) {
            return privateArea.intervener;
        }
    }

    login(credentials) {
        const headers = { 'X-Request-Id': uuidv4() };
        return this.post('/onboarding/login', credentials, headers);
    }

    /**
     * @param {Object} config Axios config
     * @param {Object} body Axios config
     * @return {Object} Promise
     */
    passwordChange(config, body) {
        return this.post('/users/password-change', body, config);
    }

    /**
     * Get current user notifications
     * @param {Object} config Axios config
     * @return {Object} Response with list of notifications
     */
    getNotifications(config) {
        return this.get('/notifications', config);
    }

    /**
     * Retorna el registro de cobas_config
     * @param {Object} config Configuración de Axios
     * @param {String} keyName Palabra clave a retornar
     * @return {Object} Promesa
     */
    getConfig(config, keyName) {
        return this.get(`/config/${keyName}`, config);
    }

    /**
     * Mark notification as read
     * @param {Object} config Axios config
     * @param {Object} body Axios config
     * @param {String} uuidNotification notification uuid
     * @return {Object} Promise
     */
    readNotification(config, uuidNotification) {
        return this.patch(`/notifications/${uuidNotification}`, {}, config);
    }

    getCountries() {
        return this.get('/onboarding/countries-info');
    }

    getProvinces(code) {
        return this.get(`/onboarding/provinces/${code}`);
    }
}

const adminusersService = new AdminUsersService();

export default adminusersService;
